import { Children, useState } from "react";
import { AddIcon, ProposalIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function ProposalTemplates() {
  const [proposalList, setProposalList] = useState([
    "[Proposal Title]",
    "[Proposal Title]",
    "[Proposal Title]",
    "[Proposal Title]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Proposals</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            proposalList.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/proposals/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setProposalList(() => [...proposalList, `Copy of ${data}`]);
                  }}
                  onDelete={() => {
                    setProposalList(() =>
                      proposalList.filter((item, i) => i !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <ProposalIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
